import React, {useEffect, useState} from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { Flex } from '@chakra-ui/react';
import {
    CancelButton,
    ConfirmationButton,
    SelectInput
} from '../../components';
import {usersService} from '../../services';
import Modal from './Modal';
import {alert, errorAlert} from '../Alerts';

const ModalSeleccionarModulo = () => {
    const modal = useModal();

    const [modulo, setModulo]  = useState(null);
    const [modulos, setModulos] = useState([]);
    const closeModal = () => {
        modal.remove();
    };

    const getModulos = async() => {
        try {
            const {data} = await usersService.modulos();
            const {modulos, modulo_seleccionado_id}  = data;
            setModulos([...modulos]);
            setModulo(modulo_seleccionado_id);
        } catch (e) {
            console.log(e);
            await errorAlert(
                {
                    title: 'Error',
                    type: 'error',
                    subtitle: ' Ocurrió un error al obtener los módulos del usuario',
                    message: e.error
                },
                null,
                null
            );

        }
    };
    useEffect(() => {
        getModulos();
    }, []);

    const updateModuloActual = async() => {
        try {
            await usersService.updateSelectedModulo(modulo);
            await alert(
                {
                    title: 'Modulo seleccionado actualizado',
                    subtitle: 'Se ha actualizado el módulo seleccionado con éxito.',
                    message: 'Este módulo es el que se utilizará para la emisión de constancias de no antecedentes.'
                },
                () => {
                    modal.resolve(true);
                    modal.remove();
                }
            );
        } catch (e) {
            await errorAlert(
                {
                    title: 'Error',
                    type: 'error',
                    subtitle: ' Ocurrió un error al tratar de cambiar de módulo',
                    message: e.error
                },
                null,
                null
            );
            //modal.resolve(false);
        }
    };

    const onModuloChange = (event) => {
        const {name, value} = event;
        console.log(value);
        setModulo(value);
    };

    return (
        <Modal size={'lg'} title={'Seleccionar módulo'}>
            <ModalBody>
                <Flex className={'justify-content-center'}>
                    <SelectInput
                        id="selected_modulo"
                        name="selected_modulo"
                        placeholder={'Seleccionar módulo'}
                        value={modulo}
                        onChange={(obj) => {
                            onModuloChange(obj);
                        }}
                        style={{ width: '350px' }}
                        options={modulos}
                    ></SelectInput>
                </Flex>
            </ModalBody>
            <ModalFooter className="modal-footer-buttons">
                <CancelButton label={'Cancelar'} onClick={closeModal} />
                <ConfirmationButton label={'Aceptar'} onClick={updateModuloActual} />
            </ModalFooter>
        </Modal>
    );
};

export default NiceModal.create(ModalSeleccionarModulo);
